import { Observable, fromEvent } from "rxjs";
import { map, startWith } from "rxjs/operators";
import {TABLET_MAX_WIDTH} from "@shared/consts";

/**
  * Monitors the window resize event to track if
  * it is on a tablet or desktop screen
  */
export function isTablet(): Observable<boolean> {
     return fromEvent(window, 'resize').pipe(
       // So it sets the value first time
       startWith(<any>null),
       map(() => document.body.offsetWidth <= TABLET_MAX_WIDTH)
     );
}
